const sgConfiguration = {
  name: 'Funding Societies',
  email: 'info@fundingsocieties.com',
  country_code: 'SG',
  country_name: 'Singapore',
  currency: 'SGD - Singapore Dollar',
  currency_code: 'SGD',
  currency_symbol: 'S$',
  enableLoyaltyProgram: true,
  encryption_key: 'FS-SG',
  header_logo_classname_prefix: 'funding-societies',
  header_vertical_logo_classname_prefix: 'funding-societies-vertical',
  header_vertical_logo_path: '/assets/img/header/logo-fs-vertical.svg',
  useBusinessPortalForBorrowers: true,
  header: {
    completeAccountActivation: {
      show: true,
    },
  },
  format: {
    date: 'y-MM-dd',
    date_time: 'y-MM-dd HH:mm:ss',
    activity_date_time: 'MMM dd y HH:mm',
    decimal: '1.2-2',
    decimal_separator: '.',
    thousands_separator: ',',
    locale: 'en',
  },
  borrower_referral_email: {
    show: true,
    email: 'refer@fundingsocieties.com',
  },
  institution_id: 1,
  language: 'en',
  supportedLanguages: ['en'], // temporary hide sg-zh
  mobileAppUrl: {
    investor: {
      googlePlay: 'https://play.google.com/store/apps/details?id=com.fundingsocieties.fundingsocieties',
      appStore: 'https://apps.apple.com/sg/app/funding-societies/id1108023092'
    },
  },
  meta: {
    image: '/assets/img/icon/logo.png',
    og_type: 'information',
    twitter_card: 'summary_large_image',
    twitter_site: '@FundSocieties',
  },
  google_tag_manager_id: 'GTM-52WRXTG',
  intercom: {
    enable: true,
  },
  portfolio: {
    showBorrowerIdentity: {
      company: true,
      name: false,
    },
    tableColumnDisplay: {
      gst: false,
      withholdingTax: true,
    },
    showTaxField: true,
    columnNumber : 13,
  },
  wallet: {
    show: true,
  },
  investor: {
    overview: {
      bonus: true,
    },
    settings: {
      hasInvestorProfiles: true,
    },
  },
  investorExcludedCountries: [
    'at',
    'be',
    'bg',
    'hr',
    'cy',
    'cz',
    'dk',
    'ee',
    'fi',
    'fr',
    'de',
    'gr',
    'hu',
    'ie',
    'it',
    'lv',
    'lt',
    'lu',
    'mt',
    'nl',
    'pl',
    'pt',
    'ro',
    'sk',
    'si',
    'es',
    'se',
    'gb',
    'us',
  ],
  sendgrid_template: {
    investor_twoFa_email_template_id: 'ac59f5d5-7341-4bf8-89d8-09751f1acc97',
    borrower_twoFa_email_template_id: 'ac59f5d5-7341-4bf8-89d8-09751f1acc97',
    borrower_email_template_id: '',
    investor_email_template_id: '',
  },
  referralLink: {
    borrower: window.location.origin + '/sign-up-borrower?referral=',
    investor: window.location.origin + '/sign-up-investor?referral=',
  },
  browseLoan: {
    borrowerName: false,
    discussionForum: false,
    showOptOut: true,
    redirectToPayment: false,
    powerOfAttorney: false,
    riskDisclosureStatement: true,
    riskDisclosureStatementChecked: true,
    suitabilityAssessmentTest: true,
    suitabilityAssessmentTestChecked: true,
    personalParticularsDisclaimer: true,
    personalParticularsDisclaimerChecked: true,
    referSme: true,
    investmentInformation: false,
    investmentHistory: {
      showOutstandingDetail: true,
    },
    blog: 'https://blog.fundingsocieties.com?utm_source=mainsitesg&utm_medium=investpage',
    fundingProgress: {
      show: false,
      successfulLimit: 100,
    },
    crowdfundingTimeLeft: {
      exact: false,
      showInSuccessLoan: false,
    },
    retailInvestorInvestingLimit: {
      enable: false,
    },
  },
  referral: {
    vip: false,
  },
  image_base_url: 'assets/img/SG',
  phone_prefix: '+65',
  help: {
    general: {
      en: 'https://help.fundingsocieties.com',
    },
    borrower: {
      en: 'https://help.fundingsocieties.com/borrowers',
    },
    investor: {
      en: 'https://help.fundingsocieties.com/investors',
    },
    show: {
      publicPage: true,
      loggedInPage: true, //For submenu when user already log in
    }
  },
  story: 'https://blog.fundingsocieties.com/our-story?utm_source=mainsitesg&utm_medium=footer',
  blog: 'https://blog.fundingsocieties.com?utm_source=mainsitesg&utm_medium=footer',
  learningCenter: 'https://blog.fundingsocieties.com/learning-center?utm_source=mainsite&utm_medium=organic',
  minimizingRiskArticle: 'https://blog.fundingsocieties.com/investments/how-diversification-can-help-to-minimise-risks-in-p2p-lending?utm_source=mainsitesg&utm_medium=investpage&utm_campaign=diversify',
  maximizingInvestmentArticle: 'https://blog.fundingsocieties.com/investments/how-maximise-your-p2p-investments?utm_source=mainsitesg&utm_medium=investpage&utm_campaign=reinvest',
  mediapress: 'https://fundingsocieties.com/press/2021',
  inTheNews: 'https://fundingsocieties.com/in-the-news/2021',
  facebook: 'https://www.facebook.com/fundingsocieties/',
  linkedin: 'https://www.linkedin.com/company/funding-societies',
  twitter: 'https://twitter.com/fundsocieties',
  instagram: 'https://www.instagram.com/fundingsocieties',
  line: '',
  // Navigation configurations
  referProgram: true,
  digisign: {
    loan: false,
  },
  marketingBanner: {
    showCovidCampaignBanner: true,
  },
  menu: {
    feedback: true
  },
  showPartner: true,
  showInvestorExposureBanner: false,
  showInvestorAccreditedDeclarationBanner: true,
  showPrivacyNoticeInvoiceFinancing: false,
  showPrivacyNoticeMalay: false,
  showAddBankAccount: false,
  showTaxInvoice: true,
  showPrivacyNotice: true,
  zoho_leads_owner: null,
  zoho_leads_owner_id: null,
  zoho_leads_source: 'Website Homepage Form',
  wootricToken: 'NPS-8c7383f1',
  boltLinkBorrowPage: 'https://fsbolt.com?utm_source=website&utm_medium=landing_page_borrow',
  applyBoltBorrowPage: 'https://fsbolt.com/web/business-information?utm_source=website&utm_medium=landing_page_borrow',
  showDisclosureNotice: true,
  infoEmail: 'info@fundingsocieties.com',
  enable2Fa: true,
  enable2FaLogin: true,
  learnMoreAALink: 'https://help.fundingsocieties.com/investors/auto-invest-error-messages-explained',
  enableWootric: false,
  showLegalPopup: true,
  passportExpiredMonthLimit: 6,
  careerBambooHRLink: 'https://www.linkedin.com/company/funding-societies-modalku/jobs/',
  enableRestructuredLoan: true,
  restructuredLoanLink: 'http://help.fundingsocieties.com/en/articles/3277106-understanding-restructuring',
  websiteTermsAndConditionPdf: '/assets/legal/FundingSocieties-WebsiteTermsAndConditions.pdf',
  subDistrictDetailEnabled: false,
  navigation: {
    loginDropDown: true,
    exposeSignUpMenu: true,
    blog: {
      show: false,
      link: '',
    },
    getFunding: {
      show: false,
      link: '',
    },
  },
  dateRestrictions: {
    passportExpiry: 6,
    myInfoPassExpiry: 6,
  },
  modalPromoBanner: false,
  showFacilityLoan: false,
  showICNumberText: true,
  statistic: {
    showDefaultRate: true,
    mediaPressButton: {
      show: true,
    },
  },
  autoInvestment: {
    enableAutoInvestment: true,
    borrowerExposure: {
      show: true,
    },
    borrowerExposureWarning: {
      minimumValue: 30,
      show: true,
    },
    enableInvestIslamicOnlyToggle: false,
  },
  signUp: {
    allowedOTpChannel: ['sms'],
    automatedPrefilHowDidYouFindUs: {
      enable: true,
      referral: true,
    },
  },
  twoFa: {
    verify: true,
  },
  memberSetting: {
    agreement: {
      manualInjection: {
        show: true,
        link: '/assets/legal/Investor Manual Injection Policy.pdf',
      }
    }
  },
  reverification: {
    show: true,
    riskDisclosure: true,
    suitabilityAssessment: true,
    hideLoanCards: true,
    eKYC: false,
  },
  withdrawal: {
    allowDecimalInput: true,
  },
  footer: {
    appDownloadButton: {
      show: true,
    },
    menu: {
      media: {
        show: true,
      },
      whoWeAre: {
        show: true,
        subMenu: {
          ourStory: true,
          statistics: true,
          careers: true,
          help: true,
        },
      },
    },
  },
  analytics: {
    SearchGuru: {
      investorSignUpSuccess: false,
    },
  },
  showCreateNewLoanButton: true,
  showDashboardAgreementModal: true,
  showFSCInvestment: true,
  liveCaptureDocsForEKYC: null,
  enableEsignPerInvestment: false,
};

export default sgConfiguration;
